import { EventEmitter } from 'expo-modules-core';

export default {};
